import { vendorReceivingSlice } from './slice';

export * from './state';

const { reducer, actions } = vendorReceivingSlice;
export const {
  setCurrentStep,
  selectVendor,
  clearSelectedVendor,
  setCheckinRow,
  seedCheckinRowsFromServer,
  replaceCheckinRowsFromServer,
  setAllocationRow,
  clearAllocationRowsForVendor,
  setCheckinWindow,
  setForceClosed,
  clearVendorEntries,
  resetVendorReceivingState,
} = actions;
export default reducer;
